/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BasketDiscountCreateResponse } from '../models/basket-discount-create-response';
import { BasketDiscountResponse } from '../models/basket-discount-response';
import { bulkPricePatch } from '../fn/discounts/bulk-price-patch';
import { BulkPricePatch$Params } from '../fn/discounts/bulk-price-patch';
import { BulkPricePatchResponse } from '../models/bulk-price-patch-response';
import { bulkQuantityDiscountPatch } from '../fn/discounts/bulk-quantity-discount-patch';
import { BulkQuantityDiscountPatch$Params } from '../fn/discounts/bulk-quantity-discount-patch';
import { bulkQuantityDiscountSynchronize } from '../fn/discounts/bulk-quantity-discount-synchronize';
import { BulkQuantityDiscountSynchronize$Params } from '../fn/discounts/bulk-quantity-discount-synchronize';
import { BulkQuantityDiscountSynchronizeResponse } from '../models/bulk-quantity-discount-synchronize-response';
import { createDiscount } from '../fn/discounts/create-discount';
import { CreateDiscount$Params } from '../fn/discounts/create-discount';
import { createOrUpdateDiscounts } from '../fn/discounts/create-or-update-discounts';
import { CreateOrUpdateDiscounts$Params } from '../fn/discounts/create-or-update-discounts';
import { deleteDiscounts } from '../fn/discounts/delete-discounts';
import { DeleteDiscounts$Params } from '../fn/discounts/delete-discounts';
import { DiscountCreateResponse } from '../models/discount-create-response';
import { DiscountResponse } from '../models/discount-response';
import { getDiscountById } from '../fn/discounts/get-discount-by-id';
import { GetDiscountById$Params } from '../fn/discounts/get-discount-by-id';
import { getDiscountsList } from '../fn/discounts/get-discounts-list';
import { GetDiscountsList$Params } from '../fn/discounts/get-discounts-list';
import { PageDiscountResponse } from '../models/page-discount-response';
import { QuantityDiscountCreateResponse } from '../models/quantity-discount-create-response';
import { QuantityDiscountResponse } from '../models/quantity-discount-response';
import { SegmentDiscountCreateResponse } from '../models/segment-discount-create-response';
import { SegmentDiscountResponse } from '../models/segment-discount-response';
import { updateDiscount } from '../fn/discounts/update-discount';
import { UpdateDiscount$Params } from '../fn/discounts/update-discount';


/**
 * Discount resource endpoints. Discounts modify prices for specific product sortiment entries at specific sites. PRODUCT_ADMIN manages manual discounts; TECHNICAL_USER uses bulk synchronization endpoints (bulk-synchronize, bulk-patch-by-price-steps) for automated PRS integration.
 */
@Injectable({ providedIn: 'root' })
export class DiscountsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDiscountById()` */
  static readonly GetDiscountByIdPath = '/discounts/{discountId}';

  /**
   * Gets the specified discount.
   *
   * Returns the discount with the given discountId.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDiscountById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDiscountById$Response(params: GetDiscountById$Params, context?: HttpContext): Observable<StrictHttpResponse<(DiscountResponse | BasketDiscountResponse | QuantityDiscountResponse | SegmentDiscountResponse)>> {
    const obs = getDiscountById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified discount.
   *
   * Returns the discount with the given discountId.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDiscountById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDiscountById(params: GetDiscountById$Params, context?: HttpContext): Observable<(DiscountResponse | BasketDiscountResponse | QuantityDiscountResponse | SegmentDiscountResponse)> {
    const resp = this.getDiscountById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<(DiscountResponse | BasketDiscountResponse | QuantityDiscountResponse | SegmentDiscountResponse)>): (DiscountResponse | BasketDiscountResponse | QuantityDiscountResponse | SegmentDiscountResponse) => r.body)
    );
  }

  /** Path part for operation `updateDiscount()` */
  static readonly UpdateDiscountPath = '/discounts/{discountId}';

  /**
   * Updates specified discount.
   *
   * Updates an existing discount based on its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDiscount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDiscount$Response(params: UpdateDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateDiscount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates specified discount.
   *
   * Updates an existing discount based on its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDiscount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDiscount(params: UpdateDiscount$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateDiscount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `bulkQuantityDiscountSynchronize()` */
  static readonly BulkQuantityDiscountSynchronizePath = '/discounts/bulk-synchronize';

  /**
   * Full replacement synchronization of quantity discounts.
   *
   * Replaces the full set of quantity discounts for the specified products/sites. Existing discounts not present in the request are removed. Intended for TECHNICAL_USER (PRS integration). Returns per-item status and error codes.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkQuantityDiscountSynchronize()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkQuantityDiscountSynchronize$Response(params: BulkQuantityDiscountSynchronize$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkQuantityDiscountSynchronizeResponse>> {
    const obs = bulkQuantityDiscountSynchronize(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Full replacement synchronization of quantity discounts.
   *
   * Replaces the full set of quantity discounts for the specified products/sites. Existing discounts not present in the request are removed. Intended for TECHNICAL_USER (PRS integration). Returns per-item status and error codes.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkQuantityDiscountSynchronize$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkQuantityDiscountSynchronize(params: BulkQuantityDiscountSynchronize$Params, context?: HttpContext): Observable<BulkQuantityDiscountSynchronizeResponse> {
    const resp = this.bulkQuantityDiscountSynchronize$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BulkQuantityDiscountSynchronizeResponse>): BulkQuantityDiscountSynchronizeResponse => r.body)
    );
  }

  /** Path part for operation `bulkQuantityDiscountPatch()` */
  static readonly BulkQuantityDiscountPatchPath = '/discounts/bulk-synchronize';

  /**
   * Partial patch synchronization of quantity discounts.
   *
   * Applies partial updates to quantity discounts. Unlike PUT /bulk-synchronize, this does NOT remove existing discounts that are absent from the request — it only adds or updates. Intended for TECHNICAL_USER (PRS integration) when only a subset of discounts needs to be updated.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkQuantityDiscountPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkQuantityDiscountPatch$Response(params: BulkQuantityDiscountPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkQuantityDiscountSynchronizeResponse>> {
    const obs = bulkQuantityDiscountPatch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Partial patch synchronization of quantity discounts.
   *
   * Applies partial updates to quantity discounts. Unlike PUT /bulk-synchronize, this does NOT remove existing discounts that are absent from the request — it only adds or updates. Intended for TECHNICAL_USER (PRS integration) when only a subset of discounts needs to be updated.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkQuantityDiscountPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkQuantityDiscountPatch(params: BulkQuantityDiscountPatch$Params, context?: HttpContext): Observable<BulkQuantityDiscountSynchronizeResponse> {
    const resp = this.bulkQuantityDiscountPatch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BulkQuantityDiscountSynchronizeResponse>): BulkQuantityDiscountSynchronizeResponse => r.body)
    );
  }

  /** Path part for operation `getDiscountsList()` */
  static readonly GetDiscountsListPath = '/discounts';

  /**
   * Gets discount list with given type.
   *
   * Finds and returns discounts only for the selected site context.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDiscountsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDiscountsList$Response(params: GetDiscountsList$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDiscountResponse>> {
    const obs = getDiscountsList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets discount list with given type.
   *
   * Finds and returns discounts only for the selected site context.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDiscountsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDiscountsList(params: GetDiscountsList$Params, context?: HttpContext): Observable<PageDiscountResponse> {
    const resp = this.getDiscountsList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageDiscountResponse>): PageDiscountResponse => r.body)
    );
  }

  /** Path part for operation `createDiscount()` */
  static readonly CreateDiscountPath = '/discounts';

  /**
   * Creates a new discount entry.
   *
   * Creates a new discount and returns the saved resource identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDiscount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDiscount$Response(params: CreateDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)>> {
    const obs = createDiscount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new discount entry.
   *
   * Creates a new discount and returns the saved resource identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDiscount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDiscount(params: CreateDiscount$Params, context?: HttpContext): Observable<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)> {
    const resp = this.createDiscount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)>): (DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse) => r.body)
    );
  }

  /** Path part for operation `deleteDiscounts()` */
  static readonly DeleteDiscountsPath = '/discounts';

  /**
   * Delete discounts.
   *
   * Delete specified discounts.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDiscounts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteDiscounts$Response(params: DeleteDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteDiscounts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete discounts.
   *
   * Delete specified discounts.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDiscounts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteDiscounts(params: DeleteDiscounts$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteDiscounts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createOrUpdateDiscounts()` */
  static readonly CreateOrUpdateDiscountsPath = '/discounts/bulk';

  /**
   * Creates and updates multiple discount entries.
   *
   * Discounts with empty id are created, otherwise they are updated.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateDiscounts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateDiscounts$Response(params: CreateOrUpdateDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)>>> {
    const obs = createOrUpdateDiscounts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates and updates multiple discount entries.
   *
   * Discounts with empty id are created, otherwise they are updated.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateDiscounts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateDiscounts(params: CreateOrUpdateDiscounts$Params, context?: HttpContext): Observable<Array<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)>> {
    const resp = this.createOrUpdateDiscounts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)>>): Array<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)> => r.body)
    );
  }

  /** Path part for operation `bulkPricePatch()` */
  static readonly BulkPricePatchPath = '/discounts/bulk-patch-by-price-steps';

  /**
   * Creates/updates quantity discounts based on price steps.
   *
   * The endpoint finds prices by merchantId, siteId and by the id of the product (packagingUnit) for the RETAILER segment, then creates/updates quantity discounts according to the price steps and sends back the status and error code if present.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkPricePatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkPricePatch$Response(params: BulkPricePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkPricePatchResponse>> {
    const obs = bulkPricePatch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates/updates quantity discounts based on price steps.
   *
   * The endpoint finds prices by merchantId, siteId and by the id of the product (packagingUnit) for the RETAILER segment, then creates/updates quantity discounts according to the price steps and sends back the status and error code if present.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkPricePatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkPricePatch(params: BulkPricePatch$Params, context?: HttpContext): Observable<BulkPricePatchResponse> {
    const resp = this.bulkPricePatch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BulkPricePatchResponse>): BulkPricePatchResponse => r.body)
    );
  }

}
